import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { SnCurrentOrganization } from '@lib/auth';

/**
 * Route guard that controls access to LPR (License Plate Recognition) export functionality.
 *
 * This guard checks if the LPR search export feature is enabled for the current organization.
 * It prevents users from accessing LPR export routes when the feature is disabled at the
 * organization level.
 x
 */
@Injectable({
  providedIn: 'root',
})
export class ViLprExportFeatureGuard implements CanActivate {
  constructor(
    private readonly _router: Router,
    private readonly currentOrganization: SnCurrentOrganization,
  ) {}

  /**
   * Determines if a route can be activated based on the LPR export feature flag.
   *
   * Checks if the `lprSearchExportEnabled` setting is enabled for the current organization.
   * If the feature is disabled, redirects the user to the plates list page and returns false.
   *
   * @returns `true` if LPR export is enabled, `false` if disabled (with redirect to plates/list)
   */
  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!this.currentOrganization.settings.lprSearchExportEnabled) {
      this._router.navigateByUrl('plates/list');
      return false;
    }

    return true;
  }
}
